<template>
  <div id="performance" class="pa-7">
    <!--タイトル-->
    <span class="subHead">
      {{ title }}
    </span>
    <!--アイコン-->
    <v-icon class="mb-2" color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--データテーブル-->
    <div
    class="mt-4 px-5"
    id="datatableTitle">
      {{ datatableTitle }}
    </div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th
            v-for="(item, i) in headers"
            :key="i"
            id="th">
            {{ item.header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in data"
          :key="i">
            <td>
              {{ item.type }}
            </td>
            <td>
              {{ item.number }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<style>
#datatableTitle {
  font-size: 18px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '実績',
      // タイトル横のアイコン
      icon: 'mdi-file-document-outline',
      // データテーブルのタイトル
      datatableTitle: 'これまで作成したサイトの種類と数',
      // データテーブルのヘッダー
      headers: [
        {
          header: '種類'
        },
        {
          header: 'サイト数'
        }
      ],
      // データテーブルの内容部分
      data: [
        {
          type: 'Joomla',
          number: '16'
        },
        {
          type: 'WIX',
          number: '1'
        },
        {
          type: 'Jimdo',
          number: '1'
        },
        {
          type: 'Googleサイト',
          number: '1'
        },
        {
          type: 'CMSを使用しない静的ホームページ',
          number: '1'
        }
      ]
    }
  }
}
</script>
